import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=c0540c8e&"
import script from "./verify.vue?vue&type=script&lang=js&"
export * from "./verify.vue?vue&type=script&lang=js&"
import style0 from "./verify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports